import React, { useState, useEffect, useContext, useRef } from "react";
import { Input, Button, Row, Col, Label } from "reactstrap";
import style from "./Bulk.module.scss";
import Symbol from "../../Fields/Symbol";
import { Field, Numeric, Combobox } from "../../../Order/Field/Field";
import { SimpleSuggest } from "../../Fields";
import { IOType, IOMode } from "../../../../IO/types";
import { onChangeHeader } from "../../IO";
import { Dispatch } from "../../store/store";
import { FormField } from "../../../../../utils";

const Edit = ({ toggle, item, services, ioType, ioMode, local, edit, entities, accountId }) => {
  const { dispatch, state } = useContext(Dispatch);
  const { io } = state;
  const [fields, setFields] = useState(item || {});
  const [errors, setErrors] = useState({});
  const [primerFetch, setPrimerFetch] = useState();
  const [balance, setBalance] = useState({
    loading: false,
    data: [],
  });
  //primeraVez.current = false

  const simpleItem = fields;
  const [denominations, setDenominations] = useState([]);
  const [denominationsItem, setDenominationsItem] = useState([]);
  const [denominationsDeposit, setDenominationsDeposit] = useState([]);
  const [denominationsReturn, setDenominationsReturn] = useState([]);
  const [assetDenominationInfo, setAssetDenominationInfo] = useState({ AssetPhysicalDenomination: false });
  const [segundoFetch, setSegundoFetch] = useState();
  const onChange = (newFields) => {
    setFields({
      ...fields,
      ...newFields,
    });

    const cleanedErrors = {};

    Object.keys(newFields).forEach((key) => (cleanedErrors[key] = undefined));

    setErrors({
      ...errors,
      ...cleanedErrors,
    });
  };

  const onEdit = () => {
    let newErrors = {};
    if (fields.Quantity == undefined || fields.Quantity === "") {
      newErrors["Quantity"] = "Required field";
    }
    if (fields.IsCurrency==false && fields.denominationsTrue == false && assetDenominationInfo.AssetPhysicalDenomination) {
      newErrors["Denominations"] = "Must select " + fields.slots + " denominations for the quantity selected";
    }
    if (ioType == IOType.Deposit && fields.IsCurrency==false && assetDenominationInfo.AssetPhysicalDenomination==true) {
      if (
        denominationsDeposit.some((item) => item.DenominationId === "") ||
        denominationsDeposit.length === 0
      ) {
        newErrors["DenominationsDeposit"] = "Must complete all fields";
      }
    }
    if (fields.IsCurrency) {
      if (fields.CurrencyId == undefined || fields.CurrencyId == "") {
        newErrors["CurrencyISO"] = "Required field";
      }
    } else {
      if (fields.AssetId == undefined || fields.AssetId == "") {
        newErrors["AssetTicker"] = "Required field";
      }
    }

    if (ioType == IOType.Withdraw && ioMode == IOMode.MultipleAccounts) {
      if (local) {
        if (fields.BankAccountName == undefined || fields.BankAccountName == "") {
          newErrors["BankAccountName"] = "Required field";
        }
      } else {
        if (fields.BankAccountName == undefined || fields.BankAccountName == "") {
          newErrors["BankAccountName"] = "Required field";
        }

        if (fields.BankAccountNumber == undefined || fields.BankAccountNumber == "") {
          newErrors["BankAccountNumber"] = "Required field";
        }
      }
    }

    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
    } else {
      edit(fields);
      toggle();
    }
  };

  useEffect(() => {
    //console.log("antes", denominationsDeposit);
    fields.Denominations !== undefined && setDenominationsItem(fields.Denominations);
    fields.Denominations !== undefined && setDenominationsDeposit(fields.Denominations);
    //console.log(fields);
    //console.log("despues", denominationsDeposit);
    services
      .GetDenominations({
        AssetId: fields.AssetId,
        AccountId: accountId,
        WithdrawId: 0,
        DepositId: 0,
        itemId: 0,
        TransferId: 0,
      })
      .then((response) => {
        let responseDenominations = response.denominations;
        for (let i = 0; i < io.items.length; i++) {
          if(io.items[i].Denominations!==undefined){
          let currentItemDenominations = io.items[i].Denominations;
          if (item.Denominations !== undefined) {
            if (
              !item.Denominations.some((obj2) =>
                currentItemDenominations.some((obj1) => obj1.DenominationId === obj2.DenominationId)
              )
            ) {
              responseDenominations = responseDenominations.filter(
                (element) =>
                  !currentItemDenominations.some((obj2) => obj2.DenominationId === element.DenominationId)
              );
            }
          } else {
            if(currentItemDenominations !== undefined){
            responseDenominations = responseDenominations.filter(
              (element) =>
                !currentItemDenominations.some((obj2) => obj2.DenominationId === element.DenominationId)
            );
            }
          }
        }
        }
        setDenominations(responseDenominations);
        onChange({
          DenominationsTotal: responseDenominations,
          slots: 0,
        });
        setSegundoFetch(true);
        //console.log(responseDenominations);
      });
  }, [fields.AssetId, accountId]);

  useEffect(() => {
    //console.log(io.Id);
    if (io.Id !== undefined && fields.Denominations === undefined && ioType == IOType.Withdraw) {
      services
        .GetDenominations({
          AssetId: fields.AssetId,
          AccountId: accountId,
          WithdrawId: io.Id,
          DepositId: -1,
          itemId: fields.Id,
          TransferId: -1,
        })
        .then((response) => {
          const responseDenominations = response.denominations;
          //console.log(responseDenominations);
          setDenominationsItem(responseDenominations);
          onChange({
            Denominations: responseDenominations,
          });
        });
    } else {
      if (io.Id !== undefined && fields.Denominations === undefined && ioType == IOType.Deposit) {
        services
          .GetDenominations({
            AssetId: fields.AssetId,
            AccountId: accountId,
            WithdrawId: -1,
            DepositId: io.Id,
            itemId: fields.Id,
            TransferId: -1,
          })
          .then((response) => {
            const responseDenominations = response.denominations;
            //console.log(responseDenominations);
            setDenominationsDeposit(responseDenominations);
            onChange({
              Denominations: [...io.Denominations, responseDenominations],
            });
          });
      }
    }
    //console.log(fields);
  }, [segundoFetch]);

  useEffect(() => {
    if (accountId && !fields.IsCurrency && fields.AssetId) {
      setBalance({ ...balance, loading: true });
      services
        .fetchAccountSellingPower({ accountId: accountId, assetId: fields.AssetId })
        .then((response) => {
          const { sellingpower } = response.response;
          setBalance({ ...balance, data: sellingpower });
        });
    } else {
      setBalance({ ...balance, data: [] });
    }
    setBalance({ ...balance, loading: false });
    services.fetchGetAssetInformation({ assetId: fields.AssetId }).then((response) => {
      if (response.info.AssetPhysicalDenomination) {
        setAssetDenominationInfo({
          AssetPhysicalDenomination: response.info.AssetPhysicalDenomination,
          AssetSheetSize: response.info.AssetSheetSize,
          SlotsQuantity: 0,
        });
        setPrimerFetch(true);
      } else {
        setAssetDenominationInfo({
          AssetPhysicalDenomination: false,
          AssetSheetSize: 0,
          SlotsQuantity: 0,
        });
      }
      //console.log("response:", response.info);
      //setDecimalAmount(response.info.SubAssetClassDecimalPlaces);
    });
  }, [fields.AssetId]);

  useEffect(() => {
    if (assetDenominationInfo.AssetPhysicalDenomination && ioType == IOType.Withdraw && fields.Quantity) {
      let slots = Math.ceil(fields.Quantity / assetDenominationInfo.AssetSheetSize);
      setAssetDenominationInfo({
        ...assetDenominationInfo,
        SlotsQuantity: slots,
      });
      let i;
      if (slots > denominationsReturn.length) {
        //selecciono menos denominations de los marcados en cantidad
        i = false;
      } else if (slots < denominationsReturn.length) {
        //seleciono mas denominations de los marcados en cantidad
        i = false;
      } else {
        i = true;
      }
      onChange({
        denominationsTrue: i,
        slots: slots,
      });
    }
  }, [fields.Quantity, denominationsReturn.length, fields.AssetId]);

  useEffect(() => {
    //console.log(fields, assetDenominationInfo, ioType);
    if (assetDenominationInfo.AssetPhysicalDenomination && ioType == IOType.Deposit && fields.Quantity) {
      let slots = Math.ceil(fields.Quantity / assetDenominationInfo.AssetSheetSize);
      //console.log(slots, fields.Quantity);
      setAssetDenominationInfo({
        ...assetDenominationInfo,
        SlotsQuantity: slots,
      });

      if (slots > denominationsDeposit.length) {
        for (let i = 0; i < slots; i++) {
          denominationsDeposit[i] = denominationsDeposit[i]
            ? denominationsDeposit[i]
            : { key: i, DenominationId: "" };
        }
      } else {
        //remove the last elements of the array
        denominationsDeposit.splice(slots, denominationsDeposit.length - slots);
      }
      onChange({
        Denominations: denominationsDeposit,
      });
    }
  }, [fields.Quantity, fields.AssetId, primerFetch]);

  const onChangeDenomination = (checked, value, index) => {
    let denominationResult = denominationsReturn;
    if (checked) {
      denominationsReturn.push({ key: index, DenominationId: value });
    } else {
      const updatedDenomination = denominationsReturn.filter((item) => item.key !== index);
      setDenominationsReturn(updatedDenomination);
      denominationResult = updatedDenomination;
    }
    onChange({
      Denominations: denominationResult,
    });
  };

  const onChangeDenominationDeposit = (value, index) => {
    denominationsDeposit[index].DenominationId = value;
    onChange({
      Denominations: denominationsDeposit,
    });
  };
  return (
    <div className={style.edit}>
      <div className={style.form}>
        {/* ##### Quantity ###### */}
        <Field label={"Quantity"} error={errors.Quantity}>
          <Numeric
            value={parseFloat(fields.Quantity).toFixed(fields.decimal || 2)}
            placeholder={"Quantity"}
            onChange={(v) => onChange({ Quantity: v })}
            invalid={!!errors.Quantity}
            dataTypeDecimalName="quantity"
          />
        </Field>

        {/* ##### Symbol ###### */}
        <Symbol
          ioType={ioType}
          accountId={accountId}
          isCurrency={fields.IsCurrency}
          onChange={(values) => onChange(values)}
          error={fields.IsCurrency ? errors.CurrencyISO : errors.AssetTicker}
          disabled={false}
          value={fields.IsCurrency ? fields.CurrencyISO : fields.AssetTicker}
          fetchSearchSymbol={services.fetchSearchSymbol}
        />

        <Field noLabel style={{ width: "100%" }}>
          {assetDenominationInfo.AssetPhysicalDenomination && ioType == IOType.Withdraw && (
            <div style={{ width: "100%", marginTop: "0px", paddingTop: "0px" }}>
              <Field
                  noLabel
                  style={{ fontSize: "15px", fontWeight: "bold" }}
                  //error={errors.simple_Denominations}
                >
                  Denominations
                </Field>{" "}
              {!fields.denominationsTrue && <Field noLabel error={errors.Denominations}></Field>}
              <hr style={{ border: "1px solid #ccc" }} />
              <div>
                {segundoFetch && (
                  <Row className="align-items-center mb-3">
                    {denominations.map((denomination, key) => (
                      <Col key={key} md={6}>
                        <div className="d-flex align-items-center">
                        <Input
                          checked={
                            fields.Denominations == undefined
                              ? false
                              : fields.Denominations.some(
                                  (item) => item.DenominationId == denomination.DenominationId
                                )
                          }
                          type="checkbox"
                          style={{
                            cursor: "pointer",
                            position: "relative", 
                            marginLeft: "0rem",   
                            margin: 0,
                          }}
                          onChange={(e) =>
                            onChangeDenomination(e.target.checked, denomination.DenominationId, key)
                          }
                        />
                        <Label className="ml-2" style={{ marginBottom: 0, marginLeft: "8px" }}>{denomination.DenominationTicker}</Label>
                        </div>
                      </Col>
                    ))}
                  </Row>
                )}
              </div>
            </div>
          )}
        </Field>
        <Field noLabel style={{ width: "100%" }}>
          {assetDenominationInfo.AssetPhysicalDenomination && ioType == IOType.Deposit && (
            <div>
              <Field
                noLabel
                style={{ fontSize: "15px", fontWeight: "bold" }}
                error={errors.DenominationsDeposit}
              >
                Denominations
              </Field>{" "}
              <hr style={{ border: "1px solid #ccc" }} />
              <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
              <Row className="align-items-center mb-3">
                {segundoFetch &&
                  denominationsDeposit.map((denomination, index) => (
                    <Col key={index} md={6}>
                      <FormField
                        name={"Denomination"}
                        placeholder={"Denomination"}
                        value={denomination.DenominationId}
                        onChange={(name, value) => onChangeDenominationDeposit(value, index)}
                      />
                    </Col>
                  ))}
              </Row>
              </div>
            </div>
          )}
        </Field>

        {/* ##### Bank Account ##### */}
        {ioType == IOType.Withdraw && ioMode == IOMode.MultipleAccounts && (
          <React.Fragment>
            {local && (
              <Field label={"Bank Account"} error={errors.BankAccountName} description={null}>
                <Combobox
                  value={fields.BankAccountItemId}
                  items={entities.accountBanks.map((a) => ({
                    id: a.BankAccountItemId,
                    description: `${a.BankAccountName} - ${a.BankAccountNumber}`,
                  }))}
                  disabled={false}
                  invalid={!!errors.BankAccountName}
                  onChange={(id) => onChange(entities.accountBanks.find((a) => a.BankAccountItemId == id))}
                  emptyLabel={"Bank Account"}
                />
              </Field>
            )}

            {!local && (
              <React.Fragment>
                <Field label={"Bank"} error={errors.BankAccountName}>
                  <Input
                    type={"text"}
                    placeholder={"Bank"}
                    value={fields.BankAccountName || ""}
                    invalid={!!errors.BankAccountName}
                    onChange={(e) => onChange({ BankAccountName: e.target.value })}
                    disabled={false}
                  />
                </Field>
                <Field label={"#Account"} error={errors.BankAccountNumber}>
                  <Input
                    type={"text"}
                    placeholder={"#Account"}
                    value={fields.BankAccountNumber || ""}
                    invalid={!!errors.BankAccountNumber}
                    onChange={(e) => onChange({ BankAccountNumber: e.target.value })}
                    disabled={false}
                  />
                </Field>

                {/* ##### ABA/SWIFT ###### */}
                <Field label={"ABA/SWIFT"} error={errors.ABASWIFT}>
                  <Input
                    type={"text"}
                    placeholder={"ABA/SWIFT"}
                    value={fields.ABASWIFT || ""}
                    onChange={(e) => onChange({ ABASWIFT: e.target.value })}
                    disabled={false}
                  />
                </Field>

                {/* ##### Intermediary Bank ###### */}
                <Field label={"Intermediary Bank"} error={errors.IntermediaryBank}>
                  <Input
                    type={"text"}
                    placeholder={"Intermediary Bank"}
                    value={fields.IntermediaryBank || ""}
                    onChange={(e) => onChange({ IntermediaryBank: e.target.value })}
                    disabled={false}
                  />
                </Field>

                {/* ##### Intermediary ABA/SWIFT ###### */}
                <Field label={"Intermediary ABA/SWIFT"} error={errors.IntermediaryABASwift}>
                  <Input
                    type={"text"}
                    placeholder={"Intermediary ABA/SWIFT"}
                    value={fields.IntermediaryABASwift || ""}
                    onChange={(e) => onChange({ IntermediaryABASwift: e.target.value })}
                    disabled={false}
                  />
                </Field>

                {/* ##### Country ###### */}
                <Field label={"Country"} error={errors.CountryName}>
                  <Input
                    type={"text"}
                    placeholder={"Country"}
                    value={fields.CountryName}
                    onChange={(e) => onChange({ CountryName: e.target.value })}
                    invalid={!!errors.CountryName}
                    disabled={false}
                  />
                </Field>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
        <div
          className={style.actions}
          style={local ? { width: "100px", display: "flex", justifyContent: "space-between" } : {}}
        >
          <Button className={"btn-sm"} color="light" onClick={toggle}>
            {true ? "Cancel" : "Close"}
          </Button>{" "}
          <Button className={"primary btn-sm"} color="primary" onClick={() => onEdit()}>
            {item.Id ? "Edit" : "Add"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Edit;
